import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';

@Component({
    selector: 'fcp-breadcrumb',
    standalone: true,
    imports: [CommonModule, BreadcrumbModule],
    styleUrl: './fcp-breadcrumb.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    template: `<p-breadcrumb [model]="breadcrumbItems()" [home]="homeMenuItem()"></p-breadcrumb>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FcpBreadcrumbComponent {
    e2e = input<string | null>(null);
    model = input<FcpBreadcrumbItem[]>([]);
    home = input<FcpBreadcrumbItem | null>(null);

    breadcrumbItems = computed<MenuItem[]>(() => this.model().map((item) => this.convertToMenuItem(item)));
    homeMenuItem = computed<MenuItem | undefined>(() => {
        const home = this.home();
        return home ? this.convertToMenuItem(home) : undefined;
    });

    private convertToMenuItem(item: FcpBreadcrumbItem): MenuItem {
        return {
            label: item.label,
            icon: item.icon,
            url: item.url,
            routerLink: item.routerLink,
            queryParams: item.queryParams,
            disabled: item.disabled,
            command: item.command
        };
    }
}

export interface FcpBreadcrumbItem {
    label?: string;
    icon?: string;
    url?: string;
    routerLink?: unknown;
    queryParams?: { [k: string]: unknown };
    disabled?: boolean;

    // Command to execute when the breadcrumb item is clicked
    command?: (event?: unknown) => void;
}
